import alertIcon from 'shared/assets/images/icons/alert-circle.svg';
import infoIcon from 'shared/assets/images/icons/info-icon.svg';
import warningIcon from 'shared/assets/images/icons/warning-triangle.svg';

export enum MESSAGE_TYPES {
  INFO = 'INFO',
  WARNING = 'WARNING',
  DANGER = 'DANGER',
}

export const ICONS_BY_MESSAGE_TYPE = {
  [MESSAGE_TYPES.INFO]: infoIcon,
  [MESSAGE_TYPES.WARNING]: warningIcon,
  [MESSAGE_TYPES.DANGER]: alertIcon,
};
